export default "__VITE_ASSET__wMdzJm2k__"